module.exports = __webpack_public_path__ + "static/media/TimeZonesQuizThumb.0bbf969c.jpg";